import script from "./curriculumForm.vue?vue&type=script&setup=true&lang=js"
export * from "./curriculumForm.vue?vue&type=script&setup=true&lang=js"

import "./curriculumForm.vue?vue&type=style&index=0&id=1f0a68fd&lang=scss"

const __exports__ = script;

export default __exports__